<template>
    <div>
        <span class="text-green">
            {{ title }}
        </span>

        <template v-if="store.form.steps.stage('workshops').visible.value">
            <div v-if="store.form.fields.value.workshops[timeslotId]">
                <strong class="text-primary-dark">
                    {{ store.form.fields.value.workshops[timeslotId].name }}
                </strong>
            </div>

            <div v-else>
                <strong class="text-red">None selected</strong>
            </div>  
        </template>
    </div>
</template>

<script setup>
    import store from "@app/booking/state/store.js"
    import { computed } from "vue"
    import dayjs from 'dayjs'
	import AdvancedFormat from 'dayjs/plugin/advancedFormat'

	dayjs.extend(AdvancedFormat)

    const props = defineProps({
        timeslotId : [String, Number],
    })

    const timeslot = computed(
        () => store.data.event.details.value.timeslots.find(
            (timeslot) => timeslot.id == props.timeslotId 
        )
    )

    const time = computed(
        () => {
            const startsAt = dayjs(timeslot.value.starts_at, 'YYYY-MM-DD HH:mm')
            const endsAt = dayjs(timeslot.value.ends_at, 'YYYY-MM-DD HH:mm')

            if(startsAt.isSame(endsAt)){
                return startsAt.format('Do MMMM YYYY HH:mm')
            }

            if(startsAt.isSame(endsAt, 'day')){
                return `${startsAt.format('Do MMMM YYYY, HH:mm')} - ${endsAt.format('HH:mm')}`
            }

            return `${startsAt.format('Do MMMM YYYY, HH:mm')} - ${endsAt.format('Do MMMM YYYY, HH:mm')}`
        }
    )

    const title = computed(
        () =>  `${timeslot.value.name} - ${time.value}`
    )
</script>